import { render, staticRenderFns } from "./AutoEducationalBackgrounds.vue?vue&type=template&id=f5e92bce"
import script from "./AutoEducationalBackgrounds.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoEducationalBackgrounds.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AutoEducationalBackgrounds.vue?vue&type=style&index=0&id=f5e92bce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports